import { Token, Typeahead } from "react-bootstrap-typeahead";
import StateHelper from "../../utils/StateHelper";

import "./Typeahead.css";
import { ColumnIds, PageName } from "../../utils/types";
import { InputGroup } from "react-bootstrap";
import AutocompleteIncludeExclude from "./AutocompleteIncludeExclude";

//https://github.com/ericgio/react-bootstrap-typeahead

function isReadOnly(option) {
  const pageState = StateHelper.getPageState();
  if (pageState.page === PageName.performanceReports) {
    if (option.id === ColumnIds.campaignSource || option.id === ColumnIds.campaignSourceAlias) {
      return true;
    }
  }

  if (pageState.pivotBy) {
    if (option.id === ColumnIds.date || option.id === ColumnIds.week || option.id === ColumnIds.month) {
      return true;
    }
  }
  return false;
}

export default function Autocomplete(props) {
  let renderToken = null;
  if (props.renderToken) {
    renderToken = (option, props, idx) => {
      return (
        <Token
          key={idx}
          option={option}
          onRemove={isReadOnly(option) ? undefined : () => props.onRemove(option)}
        >
          {option.name}
        </Token>
      );
    };
  }

  return (
    <InputGroup>
      {
        props.useIncludeExclude ? 
          <AutocompleteIncludeExclude
            defaultIncludeExclude={props.defaultIncludeExclude}
            includeExcludeOnChange={props.includeExcludeOnChange}
            disabled={props.disabled}
          />
        :
          null
      }
      <Typeahead 
        allowNew={props.allowNew||undefined}
        renderMenu={props.renderMenu||undefined}
        renderMenuItem={props.renderMenuItem||undefined}
        renderMenuItemChildren={props.renderMenuItemChildren||undefined} 
        size="sm" 
        newSelectionPrefix={props.newSelectionPrefix}
        onInputChange={props.onInputChange||undefined}
        placeholder={props.placeholder} 
        id={"id" + props.reactKey} 
        key={props.reactKey} 
        labelKey={props.labelKey} 
        multiple={props.multiple}
        onChange={props.onChange} 
        onKeyDown={props.onKeyDown}
        options={props.options}
        onBlur={props.onBlur}
        style={{...props.style, fontSize: 11}}
        onMenuToggle={props.onMenuToggle}
        // defaultSelected={props.defaultSelected} 
        selected={props.selected}
        clearButton
        filterBy={props.filterBy||undefined}
        paginate={props.paginate||undefined}
        maxResults={props.maxResults||undefined} 
        ref={props.reactRef}
        disabled={props.disabled}
        renderToken={renderToken||undefined}
      />
    </InputGroup>
  );
}